var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoArrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 107,
    viewBox: "0 0 100 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 53.5C66.0001 54.1583 65.8637 54.8095 65.5994 55.4128C65.3351 56.0161 64.9486 56.5586 64.464 57.0062L42.0643 77.7246C41.1308 78.5869 39.8916 79.0444 38.6194 78.9966C37.3471 78.9488 36.1461 78.3995 35.2804 77.4696C34.4148 76.5397 33.9554 75.3053 34.0034 74.0381C34.0514 72.7708 34.6029 71.5745 35.5364 70.7122L54.1474 53.5L35.5364 36.2878C34.6029 35.4255 34.0514 34.2292 34.0034 32.9619C33.9554 31.6947 34.4148 30.4603 35.2804 29.5304C36.1461 28.6005 37.3471 28.0512 38.6194 28.0034C39.8916 27.9556 41.1308 28.4131 42.0643 29.2754L64.464 49.9938C64.9486 50.4414 65.3351 50.9839 65.5994 51.5872C65.8637 52.1905 66.0001 52.8417 66 53.5Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowPagination);
export default __webpack_public_path__ + "static/media/ico_arrow_pagination.017aceba52fece505d5af5914aee438d.svg";
export { ForwardRef as ReactComponent };